/**
 * An agency's client portal on its own address (Professional and Business plans), e.g. seo.theiragency.com: the
 * same app, served at that address with the API under it, so its sign-in cookies stay there.
 * Arva SEO's own addresses (and local development) never are.
 */
export function isPortalHost(hostname: string): boolean {
  return !/(^|\.)arvaseo\.com$/.test(hostname) && !['localhost', '127.0.0.1', '[::1]'].includes(hostname)
}

export const portalMode = typeof window !== 'undefined' && isPortalHost(window.location.hostname)
